/* ==========================================================================
   WSPR designer app buttons – assets/wspr-designer.js (all pages, defer; loaded by the WSPR header)
   TB-007: the "Add to project" bookmark on product cards ([data-wspr-card-save]).
   Saves the card's first available variant through the designer app's JSON endpoint
   (/apps/designer/projects/save: GET = visitor state + projects, POST = add to a project).
   The picker mirrors the app block's (extensions/save-to-project/assets/save-to-project.js):
   choose a project or create one, optional space / quantity / note. Signed-out visitors get the
   log-in and apply links, signed-in non-designers the apply link.
   TB-004: makes the product page "Save to project" app block send the variant currently picked
   in the dropdown (see the end of this file).
   ========================================================================== */
(function () {
  'use strict';
  if (window.__wsprCardSave) return;
  window.__wsprCardSave = true;

  var PROXY = '/apps/designer';
  var TITLE_ID = 'wspr-card-save-title';
  var RADIO = 'wspr-card-save-project';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var overlay = null;
  var dialog = null;
  var content = null;
  var item = null; // { btn, productId, variantId, title, variantTitle, image }
  var isOpen = false;
  var prevOverflow = '';

  function build() {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.className = 'wspr-stp-overlay';
    overlay.hidden = true;
    overlay.innerHTML =
      '<div class="wspr-stp-dialog" role="dialog" aria-modal="true" aria-labelledby="' + TITLE_ID + '" tabindex="-1">' +
      '<div class="wspr-stp-handle"></div><div class="wspr-stp-content"></div></div>';
    document.body.appendChild(overlay);
    dialog = overlay.querySelector('.wspr-stp-dialog');
    content = overlay.querySelector('.wspr-stp-content');
    overlay.addEventListener('mousedown', function (e) { overlay.__down = e.target === overlay; });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay && overlay.__down) close();
    });
  }

  function subtitle() {
    var t = item.title || '';
    if (item.variantTitle && item.variantTitle !== 'Default Title') t += ' · ' + item.variantTitle;
    return t;
  }

  function header() {
    var thumb = item.image
      ? '<img class="wspr-stp-thumb" src="' + esc(item.image) + '" alt="">'
      : '<div class="wspr-stp-thumb"></div>';
    return '<div class="wspr-stp-head">' + thumb +
      '<div class="wspr-stp-headtext"><h2 class="wspr-stp-title" id="' + TITLE_ID + '">Add to project</h2>' +
      '<p class="wspr-stp-sub">' + esc(subtitle()) + '</p></div>' +
      '<button type="button" class="wspr-stp-close" aria-label="Close">×</button></div>';
  }

  function setBody(html) {
    content.innerHTML = header() + '<div class="wspr-stp-body">' + html + '</div>';
    content.querySelector('.wspr-stp-close').addEventListener('click', close);
  }

  function onKey(e) {
    if (e.key === 'Escape' || e.key === 'Esc') { e.stopPropagation(); close(); }
  }

  function open(btn) {
    build();
    item = {
      btn: btn,
      productId: btn.getAttribute('data-product-id'),
      variantId: btn.getAttribute('data-variant-id'),
      title: btn.getAttribute('data-title'),
      variantTitle: btn.getAttribute('data-variant-title'),
      image: btn.getAttribute('data-image')
    };
    isOpen = true;
    overlay.hidden = false;
    prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
    setBody('<p class="wspr-stp-msg">Loading…</p>');
    dialog.focus();
    fetch(PROXY + '/projects/save', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('bad'); return r.json(); })
      .then(function (j) { if (isOpen) render(j); })
      .catch(function () {
        if (isOpen) setBody('<p class="wspr-stp-msg wspr-stp-error">Something went wrong. Please try again.</p>');
      });
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    overlay.hidden = true;
    document.body.style.overflow = prevOverflow;
    document.removeEventListener('keydown', onKey);
    if (item && item.btn && document.contains(item.btn)) item.btn.focus();
  }

  function render(j) {
    var state = j || {};
    if (state.state === 'anonymous') {
      setBody('<p class="wspr-stp-msg">Save products to projects with a Let’s WSPR designer account.</p>' +
        '<div class="wspr-stp-actions"><a class="wspr-stp-btn wspr-stp-btn--dark" href="' + esc(state.loginUrl) + '">LOG IN</a>' +
        '<a class="wspr-stp-btn wspr-stp-btn--outline" href="' + esc(state.applyUrl) + '">APPLY FOR AN ACCOUNT</a></div>');
    } else if (state.state === 'apply') {
      setBody('<p class="wspr-stp-msg">Apply for a designer account to save products to projects.</p>' +
        '<div class="wspr-stp-actions"><a class="wspr-stp-btn wspr-stp-btn--dark" href="' + esc(state.applyUrl) + '">APPLY FOR AN ACCOUNT</a></div>');
    } else if (state.state === 'ready') {
      renderForm(state);
    } else {
      setBody('<p class="wspr-stp-msg wspr-stp-error">Something went wrong. Please try again.</p>');
    }
  }

  function renderForm(state) {
    var projects = state.projects || [];
    var html = '<form class="wspr-stp-form" novalidate><div class="wspr-stp-label">PROJECT</div><div class="wspr-stp-projects">';
    projects.forEach(function (p, i) {
      var n = Number(p.itemCount) || 0;
      html += '<label class="wspr-stp-row"><input type="radio" name="' + RADIO + '" value="' + esc(p.id) + '"' + (i === 0 ? ' checked' : '') + '>' +
        '<span class="wspr-stp-radio"></span><span class="wspr-stp-rowname">' + esc(p.name) + '</span>' +
        '<span class="wspr-stp-count">' + n + (n === 1 ? ' item' : ' items') + '</span></label>';
    });
    html += '</div>';
    html += '<button type="button" class="wspr-stp-new">+ New project</button>';
    html += '<div class="wspr-stp-grid"><div><div class="wspr-stp-label">SPACE</div><select class="wspr-stp-input wspr-stp-select" name="space"></select></div>' +
      '<div><div class="wspr-stp-label">QTY</div><input class="wspr-stp-input" type="number" name="quantity" min="1" value="1" inputmode="numeric"></div></div>' +
      '<div><div class="wspr-stp-label">NOTE (OPTIONAL)</div><input class="wspr-stp-input" type="text" name="note" maxlength="500" placeholder="e.g. confirm fabric against client’s rug"></div>' +
      '<div class="wspr-stp-error" role="alert" hidden></div>' +
      '<button type="submit" class="wspr-stp-submit">Save to project</button>';
    if (state.pending) html += '<p class="wspr-stp-pending">Your account is pending approval. You can build projects now.</p>';
    html += '</form>';
    setBody(html);

    var form = content.querySelector('.wspr-stp-form');
    var list = form.querySelector('.wspr-stp-projects');
    var newBtn = form.querySelector('.wspr-stp-new');
    var select = form.querySelector('select');
    var submit = form.querySelector('.wspr-stp-submit');
    var errEl = form.querySelector('.wspr-stp-error');
    var qty = form.querySelector('[name="quantity"]');
    var newInput = null;

    function selected() { return form.querySelector('input[name="' + RADIO + '"]:checked'); }

    function projectById(pid) {
      for (var i = 0; i < projects.length; i++) if (String(projects[i].id) === pid) return projects[i];
      return null;
    }

    function updateSpaces(keep) {
      var r = selected();
      var p = r && r.value !== 'new' ? projectById(r.value) : null;
      var spaces = p ? p.spaces || [] : [];
      var current = keep ? select.value : null;
      var h = '';
      spaces.forEach(function (s, i) {
        var on = current !== null ? String(s.id) === current : i === 0;
        h += '<option value="' + esc(s.id) + '"' + (on ? ' selected' : '') + '>' + esc(s.name) + '</option>';
      });
      var noneOn = current !== null ? current === '' || !spaces.some(function (s) { return String(s.id) === current; }) : !spaces.length;
      h += '<option value=""' + (noneOn ? ' selected' : '') + '>No space</option>';
      select.innerHTML = h;
      updateLabel();
      if (p && !p.fresh) refreshSpaces(p);
    }

    // The list comes from search, which can lag behind a newly added space; re-read the project's spaces.
    function refreshSpaces(p) {
      p.fresh = true;
      fetch(PROXY + '/projects/save?project=' + encodeURIComponent(p.id), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (j) {
          if (!j || !Array.isArray(j.spaces)) return;
          p.spaces = j.spaces;
          var r = selected();
          if (r && r.value === String(p.id)) updateSpaces(true);
        })
        .catch(function () { p.fresh = false; });
    }

    function updateLabel() {
      var o = select.options[select.selectedIndex];
      submit.textContent = o && o.value ? 'Save to ' + o.text : 'Save to project';
    }

    function addNew() {
      if (newInput) { newInput.closest('label').querySelector('input[type=radio]').checked = true; updateSpaces(); newInput.focus(); return; }
      var row = document.createElement('label');
      row.className = 'wspr-stp-row wspr-stp-row--new';
      row.innerHTML = '<input type="radio" name="' + RADIO + '" value="new" checked><span class="wspr-stp-radio"></span>' +
        '<input type="text" class="wspr-stp-newname" placeholder="Project name" maxlength="120" aria-label="Project name">';
      list.appendChild(row);
      newInput = row.querySelector('.wspr-stp-newname');
      newBtn.hidden = true;
      updateSpaces();
      newInput.focus();
    }

    form.addEventListener('change', function (e) {
      if (e.target.name === RADIO) updateSpaces(false);
      else if (e.target === select) updateLabel();
    });
    newBtn.addEventListener('click', addNew);
    if (!projects.length) addNew();
    else updateSpaces();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errEl.hidden = true;
      var r = selected();
      var isNew = !r || r.value === 'new';
      var name = newInput ? newInput.value.trim() : '';
      if (isNew && !name) {
        errEl.textContent = 'Please name your new project.';
        errEl.hidden = false;
        newInput && newInput.focus();
        return;
      }
      var q = parseInt(qty.value, 10);
      if (!(q >= 1)) q = 1;
      var params = {
        project: isNew ? 'new' : r.value,
        space: select.value,
        variant: String(item.variantId),
        product: String(item.productId),
        quantity: String(q),
        note: form.querySelector('[name="note"]').value.trim()
      };
      if (isNew) params.projectName = name;
      submit.disabled = true;
      submit.textContent = 'Saving…';
      fetch(PROXY + '/projects/save', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body: new URLSearchParams(params)
      })
        .then(function (res) { if (!res.ok && res.status !== 422) throw new Error('bad'); return res.json(); })
        .then(function (j) {
          if (j && j.ok) return success(j);
          throw new Error((j && j.error) || '');
        })
        .catch(function (err) {
          errEl.textContent = (err && err.message && err.message !== 'bad') ? err.message : 'Something went wrong. Please try again.';
          errEl.hidden = false;
          submit.disabled = false;
          updateLabel();
        });
    });
  }

  function success(j) {
    if (item && item.btn) {
      item.btn.classList.add('is-saved');
      item.btn.setAttribute('title', 'Saved to ' + (j.projectName || 'project'));
    }
    setBody('<div class="wspr-stp-done"><span class="wspr-stp-tick"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2.5 6.2l2.2 2.2 4.8-4.8"/></svg></span>' +
      '<span>Saved to ' + esc(j.spaceName || j.projectName) + '</span></div>' +
      '<div class="wspr-stp-actions"><a class="wspr-stp-btn wspr-stp-btn--dark" href="' + esc(j.projectUrl) + '">VIEW PROJECT</a>' +
      '<button type="button" class="wspr-stp-btn wspr-stp-btn--outline wspr-stp-keep">KEEP BROWSING</button></div>');
    content.querySelector('.wspr-stp-keep').addEventListener('click', close);
  }

  // Delegated: cards come and go with filtering, infinite scroll and section reloads.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-wspr-card-save]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    open(btn);
  });

  /* TB-004: the app block (extensions/save-to-project) takes its variant from the first
     form[action*="/cart/add"] [name="id"] on the page, else the variant the page loaded with.
     This theme's product page has no such form (Add to cart is the <xo-cart-add> element and the
     Buy-now form is only rendered with dynamic checkout on), so a changed dropdown was ignored and
     every save sent the first variant (or another product's form, e.g. in a drawer, if one came
     first). Just before the block's own click handler runs (capture phase), put a hidden form with
     the current variant first in the document, and remove it right after. The theme keeps the
     current variant on <xo-product xo-selected-or-first-available-variant-id> and in ?variant=. */
  function currentVariant(root) {
    var product = root.closest('xo-product');
    var v = product && product.getAttribute('xo-selected-or-first-available-variant-id');
    if (!v) {
      var m = /[?&]variant=(\d+)/.exec(window.location.search);
      v = m && m[1];
    }
    return v || root.getAttribute('data-variant-id');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.wspr-stp__btn') : null;
    var root = btn && btn.closest('.wspr-stp');
    if (!root) return;
    var v = currentVariant(root);
    if (!v) return;
    var form = document.createElement('form');
    form.setAttribute('action', '/cart/add');
    form.hidden = true;
    form.setAttribute('aria-hidden', 'true');
    form.className = 'wspr-stp-variant';
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'id';
    input.value = v;
    form.appendChild(input);
    document.body.insertBefore(form, document.body.firstChild);
    setTimeout(function () { if (form.parentNode) form.parentNode.removeChild(form); }, 0);
  }, true);
})();